<template>
    <div>
        <div class="m-3 col-12 text-end">
            <a href="/dashboard/bootcamps/grid" class="btn btn-utel btn-inverted" alt="crear" title="crear">
                Ver todos los bootcamps
            </a>

            <a href="/dashboard/bootcamps/create" class="btn btn-utel" alt="crear" title="crear">
                Agregar bootcamps
            </a>
        </div>

        <v-data-table :headers="headersTabs" :items="desserts" item-key="name" :search="search" :items-per-page="10"
            class="elevation-1 table table-bootcamps text-center align-middle small" loading loading-text="Cargando..."
            mobile-breakpoint="0" :footer-props="{
                    prevIcon: 'fa-solid fa-chevron-left',
                    nextIcon: 'fa-solid fa-chevron-right',
                    'items-per-page-text': 'Mostrando: ',
                    'items-per-page-options': [5, 10, 20, 30, 40, 50],
                }">
            <template v-slot:item="row">
                <tr>
                    <td>{{ row.item.id }}</td>
                    <td>
                        <div class="text-truncate-3">{{ row.item.title }}</div>
                    </td>
                    <td>
                        <div class="text-truncate-3">{{ row.item.description }}</div>
                    </td>
                    <td>{{ row.item.cta }}</td>
                    <td>{{ row.item.cta_text }}</td>
                    <td>{{ row.item.updated_at }}</td>
                    <td class="d-flex gap-2">
                        <button type="button" class="text-primary me-2" data-bs-toggle="modal" data-bs-target="#updateModal"
                            alt="Editar" title="Editar" @click="edit = row.item">
                            <i class="fa-solid fa-pen-to-square"></i>
                        </button>
                        <button type="button" class="text-primary" data-bs-toggle="modal" data-bs-target="#deleteModal"
                            alt="Eliminar este usuario" title="Eliminar este usuario" @click="destroy = row.item">
                            <i class="fa-regular fa-trash-can"></i>
                        </button>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <!-- modal agregar bootcamps -->
        <div class="modal fade" id="addModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="addModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">Agregar nuevo bootcamps</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col">
                                <label class="form-label">Título del bootcamp</label>
                                <input type="text" v-model="newBootcamps.title" class="form-control" />
                            </div>
                            <span class="text-danger" v-if="error.title">El título del bootcamp es un campo
                                obligatorio</span>
                        </div>

                        <div class="row g-3">
                            <div class="col">
                                <label class="form-label">Descripción</label>
                                <input type="text" v-model="newBootcamps.description" class="form-control" />

                                <span class="text-danger" v-if="error.description">La descripción del bootcamp es
                                    obligatorio</span>
                            </div>
                        </div>
                        <div class="row g-3">
                            <div class="col-8">
                                <label class="form-label">Link del CTA</label>
                                <input type="text" v-model="newBootcamps.cta" class="form-control" />

                                <span class="text-danger" v-if="error.cta">El link es obligatorio</span>
                            </div>
                            <div class="col-4">
                                <label class="form-label">Ficha Técnica</label>
                                <input type="file" class="form-control" name="ficha_tecnica" id="ficha_tecnica_agr"
                                    accept="application/pdf" @change="onFileUpload" />
                            </div>
                        </div>
                        <div class="row g-3">
                            <div class="col-8">
                                <label class="form-label">Mensaje del CTA</label>
                                <input type="text" v-model="newBootcamps.cta_text" class="form-control" />

                                <span class="text-danger" v-if="error.cta">El mensjae del CTA es obligatorio</span>
                            </div>

                            <div class="col-4">
                                <label class="form-label">Tiempo del Programa</label>
                                <select class="form-control" v-model="newBootcamps.program_time">
                                    <option value="5_meses">5 Meses</option>
                                    <option value="8_meses">8 Meses</option>
                                </select>

                                <span class="text-danger" v-if="error.program_time">El tiempo del programa es
                                    obligatorio</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="closeAdd" type="button" class="btn btn-utel btn-inverted d-none d-lg-block"
                            data-bs-dismiss="modal" @click="newBootcamps = []">
                            Cerrar
                        </button>
                        <button id="agregar" type="button" @click="agregarBootcamps" class="btn btn-utel text-light">
                            Guardar cambios
                        </button>
                        <button id="closeAdd" type="button" class="btn btn-utel btn-inverted d-lg-none"
                            data-bs-dismiss="modal" @click="newBootcamps = []">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!--modal delete client-->
        <div class="modal fade" id="deleteModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="deleteModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Eliminar bootcamp {{ destroy.title }}
                        </h5>
                    </div>
                    <div class="modal-body text-center">
                        <span id="response">¿Esta seguro de eliminiar el bootcamp
                            {{ destroy.title }}?</span>
                    </div>
                    <div class="modal-footer">
                        <button id="close" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
                            @click="destroy = []">
                            Cerrar
                        </button>
                        <button id="delete" type="button" @click="eliminarBootcamps" class="btn btn-outline-danger">
                            Eliminar bootcamp
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!--modal edit client-->
        <div class="modal fade" id="updateModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="updateModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title">
                            Editar bootcamps {{ edit.title }}
                        </h5>
                    </div>
                    <div class="modal-body">

                        <div class="row g-3 mt-0">
                            <div class="col-12">
                                <label class="form-label">Nombre del bootcamp</label>
                                <input type="text" v-model="edit.title" class="form-control" />
                                <span class="text-danger" v-if="error.title">El título del bootcamp es un campo
                                    obligatorio</span>
                            </div>
                        </div>

                        <div class="row g-3 mt-0">
                            <div class="col">
                                <label class="form-label">Descripción</label>
                                <textarea name="" id="" class="form-control" rows="4" v-model="edit.description"></textarea>
                                <span class="text-danger" v-if="error.description">La descripción del bootcamp es
                                    obligatoria</span>
                            </div>
                        </div>

                        <div class="row g-3 mt-0">
                            <div class="col-8">
                                <label class="form-label">Link del CTA</label>
                                <input type="text" v-model="edit.cta" class="form-control" />

                                <span class="text-danger" v-if="error.cta">El link es obligatorio</span>
                            </div>
                            <div class="col-4">
                                <label class="form-label">Ficha Técnica</label>
                                <input type="file" class="form-control" name="ficha_tecnica" id="ficha_tecnica_edt"
                                    accept="application/pdf" @change="onFileUpload" />
                            </div>
                        </div>
                        <div class="row g-3 mt-0">
                            <div class="col-8">
                                <label class="form-label">Mensaje del CTA</label>
                                <input type="text" v-model="edit.cta_text" class="form-control" />

                                <span class="text-danger" v-if="error.cta">El mensjae del CTA es obligatorio</span>
                            </div>
                            <div class="col-4">
                                <label class="form-label">Tiempo del Programa</label>
                                <select class="form-control" v-model="edit.program_time">
                                    <option value="5_meses">5 Meses</option>
                                    <option value="8_meses">8 Meses</option>
                                </select>

                                <span class="text-danger" v-if="error.program_time">El tiempo del programa es
                                    obligatorio</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="closeAdd" type="button" class="btn btn-utel btn-inverted d-none d-lg-block"
                            data-bs-dismiss="modal" @click="edit = []">
                            Cerrar
                        </button>
                        <button id="update" type="button" @click="editarBootcamps" class="btn btn-utel text-light">
                            Guardar cambios
                        </button>
                        <button id="closeAdd" type="button" class="btn btn-utel btn-inverted d-lg-none"
                            data-bs-dismiss="modal" @click="edit = []">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Button trigger modal confirmación elimina -->
        <button id="succesDeleteBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal"
            data-bs-target="#succesDelete"></button>

        <!-- Modal Confirmación Elimina -->
        <div class="modal fade" id="succesDelete" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="succesDeleteLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesDeleteLabel">
                            Eliminado
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha eliminado <br />
                        correctamente la empresa
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light" data-bs-dismiss="modal">
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["get", "headertab"],
    data() {
        return {
            search: "",
            headersTabs: this.headertab,
            url: this.get,
            desserts: [],
            edit: [],
            destroy: [],
            newBootcamps: { title: "", description: "", program_time: "5_meses", cta: "", cta_text: "" },
            error: [],
            FILE: null
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            axios.get(this.url).then((res) => {
                this.desserts = res.data;
            });
        },
        editarBootcamps() {
            let context = this;
            let btn = document.getElementById("update");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("updateModal");
            let bd = document.getElementsByClassName("modal-backdrop");

            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");

            btn.textContent = "Procesando ...";

            let InstFormData = new FormData();
            Object.entries(this.edit).forEach(([key, value]) => {
                InstFormData.append(key, value);                
            });
            if(this.FILE != null) 
                InstFormData.append('ficha_tecnica' , this.FILE, this.FILE.name);
            InstFormData.append('_method', 'PUT');

            axios
                .post(this.url + `/${this.edit.id}`, InstFormData, {headers : {'content-type': 'multipart/form-data'}})
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        btn.textContent = "Actualizar bootcamp";
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        document.querySelector('#ficha_tecnica_edt').value = null;
                        context.FILE = null;
                    }, 500);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        eliminarBootcamps() {
            const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            let succesDeleteBtn = document.getElementById("succesDeleteBtn");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.id)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Eliminar bootcamp";
                        succesDeleteBtn.click();
                    }, 500);
                })
                .catch((err) => {
                    console.log(err.error);
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });
        },
        agregarBootcamps() {
            let context = this;
            let btn = document.getElementById("agregar");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";

            let InstFormData = new FormData();
            Object.entries(this.newBootcamps).forEach(([key, value]) => {
                InstFormData.append(key, value);                
            });
            if(this.FILE != null) 
                InstFormData.append('ficha_tecnica' , this.FILE, this.FILE.name);

            axios
                .post(this.url, InstFormData, {headers : {'content-type': 'multipart/form-data'}})
                .then((res) => {
                    this.newBootcamps = {
                        title: "",
                        description: "",
                        program_time: "",
                        cta: "",
                        cta_text: "",
                    };
                    document.querySelector('#ficha_tecnica_agr').value = null;
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        btn.textContent = "Agregar bootcamp";
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        context.FILE = null;
                    }, 500);
                })
                .catch((err) => { });
        },
        filtrarPorOrden(val) {
            const value = val.target.value;
            axios.get(`${this.url}?filterOrder=${value}`).then((res) => {
                this.desserts = res.data;
            });
        },
        onFileUpload (event) {
            this.FILE = event.target.files[0]
        },
    },
};
</script>
